
import { useParams } from 'react-router-dom';
import { CourseReviewPage } from '../review/CourseReviewPage';
import { SimpleSurveyPage } from './SimpleSurveyPage';
import React from 'react';
import { AppContext } from '../comments/AppContext';
import { ICourse } from '@/shared/ICourse';
import { CourseStorageService } from '../services/CourseStorageService';
import { STEPS, PLATFORM_VERSION } from '@/shared/constants';
import { TelemetryClientService } from '../services/TelemetryClientService';
import { ErrorMessage } from '../components/ErrorMessage';
import { Box, Center, Container, Spinner } from '@chakra-ui/react';

export const SurveyPage = () => {

  const params = useParams<{ courseId: string, moduleId: string, action: string, pageId: string }>();

  const { isAuthenticated } = React.useContext(AppContext);

  const [errorMessage, setErrorMessage] = React.useState<any>();
  const [course, setCourse] = React.useState<ICourse>();
  React.useEffect(() => {
    if (params.courseId) {
      setErrorMessage(undefined);
      CourseStorageService.getCourse(params.courseId).then((loadedCourse) => {
        setCourse(loadedCourse);
      }).catch((error) => {
        setErrorMessage(error);
        TelemetryClientService.error(`Error loading course ${params.courseId}`, error);
      });
    }
  }, [params.courseId]);

  const isReviewPage = course?.coursePlatformVersion === PLATFORM_VERSION.V2
    ? (params.moduleId === STEPS.REVIEW || params.action === 'review')
    : params.moduleId === STEPS.REVIEW;

  return errorMessage ?
    <Container mt={120}>
      <ErrorMessage error={errorMessage} />
    </Container>
    : isAuthenticated && params.courseId && params.moduleId && params.action && (
      course ? (isReviewPage
        ? <CourseReviewPage course={course} setCourse={setCourse} moduleId={params.moduleId} action={params.action} pageId={params.pageId} />
        : <SimpleSurveyPage course={course} setCourse={setCourse} moduleId={params.moduleId} action={params.action} pageId={params.pageId} />
      ) : (
      <Container mt={200}>
        <Center color='fg.muted' fontSize='large'><Spinner size='lg' /><Box ml={4} >Loading course...</Box></Center>
      </Container>
      )
    );
}